/** Shopify CDN: Minification failed

Line 7:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 8:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
const Functions = {
	changeQuantity(line, quantity){
		fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ quantity: quantity, line: line })
		})
		.then(response => response.json())
		.then(data => {
			window.dispatchEvent(new CustomEvent('update-cart', { detail: data }))
		})
		.catch(errror => console.error('Error:', error));
	}
}

window.Functions = Functions
